/*
This file is located in the main branch
Last time the file was updated (UTC): [26.07.2024 9:54:27]
Permissions to update outside the main branch: [false]
*/

import { toInt, useActionsBtnContext } from '@finbeat/react-toolkit';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Prop } from 'models/api/prop';
import { RoleTableItem } from 'models/api/roles';
import Id from 'models/id';
import { useGeneralSettingsContext } from 'providers/GeneralSettingsProvider';
import { useTranslation } from 'react-i18next';
import { useRoleWorkplaceState } from './Roles';

type RoleCopyBtnProps = Id & {
    roleItem: RoleTableItem;
    fetchPropsQueryFn: (id: number | string) => Promise<Prop[]>;
};

const getNewCopyName = (name: string): string => {
    const COPY_SUFFIX = 'Copy';

    const index = name.indexOf(COPY_SUFFIX);

    if (index === -1) {
        return name + COPY_SUFFIX;
    }

    const numberStr = name.substring(index + COPY_SUFFIX.length);

    const number = toInt(numberStr) ?? 0 + 1;

    return name.substring(0, index) + COPY_SUFFIX + number;
};

export default function RoleCopyBtn({ id, roleItem: role, fetchPropsQueryFn }: RoleCopyBtnProps) {
    const { t } = useTranslation();
    const { addItemMutation } = useRoleWorkplaceState();
    const { addRequest } = useActionsBtnContext();
    const { cultures } = useGeneralSettingsContext();

    return (
        <div className="workplace-delete-btn workplace-action-btn cursor--pointer">
            <FontAwesomeIcon icon={faCopy} className="text-danger workplace-action-btn__icon" />
            <button
                className="btn border-0 p-0"
                onClick={() => {
                    addRequest({
                        content: t('BackOfficeAreYouSure'),
                        confirmCallback: async (res) => {
                            if (res && id !== undefined) {
                                const props = await fetchPropsQueryFn(id);
                                const newRole = { ...role, name: getNewCopyName(role.name) };
                                const nameTranslations = cultures.reduce<{ [key: string]: string }>(
                                    (result, culture) => {
                                        result[culture.code] = t('BackOfficeRoleName' + role.name, {
                                            lng: culture.code,
                                            defaultValue: '',
                                        });
                                        return result;
                                    },
                                    {}
                                );

                                addItemMutation.mutate({
                                    ...newRole,
                                    roles: newRole.roles?.map((i) => i.id) ?? [],
                                    nameTranslations,
                                    props: props,
                                });
                            }
                        },
                    });
                }}
            >
                {t('BackOfficeCopy')}
            </button>
        </div>
    );
}
